import { CoreIcon } from '../core-icon';
import refreshSVG from '../../assets/icons/refresh.svg';
import type { IconProps } from '../core-icon';

export const RefreshIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={refreshSVG} {...props} />;
};
